export default __webpack_public_path__ + "static/media/project-wizard-dashboards.0d7b4bee.png";